module.exports = __webpack_public_path__ + "assets/img/image-error.d157d518.svg";